export enum EActiveTab {
  Explore = "explore",
  Fav = "fav",
  Office = "office",
  Booking = "booking",
  Profile = "profile",
}
